import { render, staticRenderFns } from "./PreSettlementRules.vue?vue&type=template&id=246e584f"
import script from "./PreSettlementRules.vue?vue&type=script&lang=js"
export * from "./PreSettlementRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports